import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { SlideshowItem } from '../../models/slideshow-item';
import { AssetImageUrlPipe } from '../../../image/pipes/asset-image-url.pipe';
import { transition, trigger, useAnimation } from '@angular/animations';
import { incomingAnimation } from '../../animations/incoming-animation';
import { outgoingAnimation } from '../../animations/outgoing-animation';

@Component({
  selector: 'app-slideshow-item',
  imports: [NgOptimizedImage, AssetImageUrlPipe],
  templateUrl: './slideshow-item.component.html',
  styleUrl: './slideshow-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('animate', [
      transition(':enter', useAnimation(incomingAnimation)),
      transition(':leave', useAnimation(outgoingAnimation)),
    ]),
  ],
})
export class SlideshowItemComponent implements OnChanges {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  public readonly item = input.required<SlideshowItem>();

  protected visible = false;

  public ngOnChanges(changes: SimpleChanges): void {
    const { item } = changes;

    if (item) {
      this.visible = false;
      this.changeDetectorRef.detectChanges();
      this.visible = true;
      this.changeDetectorRef.detectChanges();
    }
  }
}
